export default "__VITE_ASSET__164f6e2a__"